import { Pipe, PipeTransform } from '@angular/core';
import { ActionButton } from '../models/action-button';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'actionButtonDisability',
  standalone: true,
})
export class ActionButtonDisabilityPipe<Action> implements PipeTransform {
  public transform(action: Nillable<ActionButton<Action>>): Nillable<boolean> {
    if (isNil(action)) {
      return action;
    }

    return action.disability$();
  }
}
